export default {"src":"/intl/_next/static/media/sentiment_dissatisfied.ead31b22.svg","height":105,"width":105,"blurWidth":0,"blurHeight":0};